import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export const useTrialData = () => {
  const { user } = useAuth();
  const [requestsUsed, setRequestsUsed] = useState(0);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { setLoading(false); return; }
    const fetchProfile = async () => {
      const { data, error } = await supabase.from('profiles').select('trial_requests_used, is_subscribed').eq('id', user.id).single();
      if (!error && data) { setRequestsUsed(data.trial_requests_used ?? 0); setIsSubscribed(data.is_subscribed ?? false); }
      setLoading(false);
    };
    fetchProfile();

    const channel = supabase.channel('trial-data-changes').on('postgres_changes', { event: '*', schema: 'public', table: 'profiles', filter: `id=eq.${user?.id}` }, (payload) => {
      const newData = payload.new as any;
      setRequestsUsed(newData.trial_requests_used ?? 0);
      setIsSubscribed(newData.is_subscribed ?? false);
    }).subscribe();

    return () => { supabase.removeChannel(channel); };
  }, [user]);

  const remainingRequests = Math.max(0, 10 - requestsUsed);

  return { remainingRequests, isSubscribed, loading, requestsUsed };
};
